import {
  jb_multi_form_css_default
} from "./chunk.TXAEMNG7.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  Animatable
} from "./chunk.V3FEQEPV.js";
import {
  applyStyles
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-multi-form/jb-multi-form.ts
var JbMultiForm = class extends Spaceable(Animatable(i)) {
  constructor() {
    super(...arguments);
    this.formsToDisplay = [];
    this._formOptions = [];
  }
  connectedCallback() {
    super.connectedCallback();
    applyStyles(this, jb_multi_form_css_default);
    this._formOptions = [
      ...this.formsToDisplay.map((form) => ({
        label: form.formTitle,
        value: form.formIdentifier
      }))
    ];
    const initialIdentifier = this.preselectedFormIdentifier ?? this.formsToDisplay[0].formIdentifier;
    if (this.preselectedForm) {
      this._currentFormProperties = this.preselectedForm;
    } else {
      this._currentFormProperties = this.formsToDisplay.find((i2) => i2.formIdentifier === initialIdentifier).form;
    }
    this.contentDuration = 150;
    this.contentStagger = 75;
  }
  createRenderRoot() {
    return this;
  }
  async firstUpdated() {
    this._trackFormChange();
    await this.updateComplete;
    const initialIdentifier = this.preselectedFormIdentifier ?? this.formsToDisplay[0].formIdentifier;
    this._select.setValue(initialIdentifier);
    if (this.promptForSelection) {
      const hiddenField = document.createElement("jb-text-field");
      hiddenField.setAttribute("requiredText", "*");
      hiddenField.setAttribute("type", "hidden");
      await this._currentForm.updateComplete;
      this._currentForm.append(hiddenField);
      this._select.value = "";
      this._currentForm.addEventListener("jb-button:clicked", async (e2) => {
        if (e2.detail.name === "submit") {
          this._validateMultiformSelector();
        }
      });
    }
  }
  _captureTracking(evt) {
    evt.stopPropagation();
  }
  _formShow(formIdentifier) {
    this._trackFormChange();
    this._currentForm.classList.add("paused");
    this.contentChildren = Array.from(this._currentForm.children);
    this.animateContent(true).then(() => {
      this._currentFormProperties = this.formsToDisplay.find((i2) => i2.formIdentifier === formIdentifier).form;
      this._currentForm.classList.remove("paused");
    });
  }
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8, colsLgUp: 6 };
  }
  async _selectChanged() {
    if (!this._select.value) return;
    const requiredField = this._currentForm?.querySelector('[requiredtext="*"]');
    if (requiredField) {
      this._currentForm?.removeChild(requiredField);
    }
    this._formShow(this._select.value);
  }
  _trackFormChange() {
    const selectRoot = this._select.shadowRoot ?? this._select;
    const selectText = selectRoot.querySelector("[data-ts-item]");
    const trackingDetail = {
      event: "ce_form",
      event_version: "v2",
      component_name: "multi-contact-form",
      form_component: this._currentForm,
      form_step_name: !selectText ? "form open" : "form type select",
      form_step_nr: !selectText ? "1" : "1.5",
      form_subject: !selectText ? "skeleton contact form" : selectText.innerText,
      form_type: "contact"
    };
    if (selectText) {
      trackingDetail.interaction_text = selectText.innerText;
    }
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: trackingDetail,
        bubbles: true,
        composed: true
      })
    );
  }
  _validateMultiformSelector() {
    const select = this.querySelector("jb-select");
    if (select.validate) {
      return select.validate();
    }
    return null;
  }
  render() {
    return b`
      <div class="wrapper">
        ${this.headline ? b`<jb-heading variant="heading-md">${this.headline}</jb-heading>` : A}
        <jb-select
          id="formSelect"
          .ariaLabels=${this.ariaLabels ?? A}
          .options=${this._formOptions}
          showLabel
          .requiredText=${this.requiredText}
          .label=${this.label}
          .placeholder=${this.promptForSelection}
          type="ismultiform"
          @jb-select:changed=${this._selectChanged}
        ></jb-select>
      </div>
      <jb-heading-context offset=${this.headline ? 1 : 0}>
        <jb-form
          .action=${this._currentFormProperties.action}
          .additionalData=${this._currentFormProperties.additionalData}
          .bordered=${this._currentFormProperties.bordered}
          .contentElements=${this._currentFormProperties.contentElements}
          .formHeader=${this._currentFormProperties.formHeader}
          .formIdentifier=${this._currentFormProperties.formIdentifier}
          .generalConcern=${this._currentFormProperties.generalConcern}
          .multiformSubline=${this._currentFormProperties.multiformSubline}
          .recipient=${this._currentFormProperties.recipient}
          .recipientPhone=${this._currentFormProperties.recipientPhone}
          .recipientPosition=${this._currentFormProperties.recipientPosition}
          .trackingSubject=${this._currentFormProperties.trackingSubject}
          .validationFieldname=${this._currentFormProperties.validationFieldname}
          displayGrid
          @jb-tracking=${this._captureTracking}
        ></jb-form>
      </jb-heading-context>
    `;
  }
};
JbMultiForm.styles = [reset_css_default, jb_multi_form_css_default];
JbMultiForm.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbMultiForm.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Array })
], JbMultiForm.prototype, "formsToDisplay", 2);
__decorateClass([
  n({ reflect: true })
], JbMultiForm.prototype, "headline", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "label", 2);
__decorateClass([
  n({ type: Object })
], JbMultiForm.prototype, "preselectedForm", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "preselectedFormIdentifier", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "promptForSelection", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "requiredText", 2);
__decorateClass([
  e("jb-form")
], JbMultiForm.prototype, "_currentForm", 2);
__decorateClass([
  r()
], JbMultiForm.prototype, "_currentFormProperties", 2);
__decorateClass([
  e("#formSelect")
], JbMultiForm.prototype, "_select", 2);
JbMultiForm = __decorateClass([
  customElement("jb-multi-form")
], JbMultiForm);

export {
  JbMultiForm
};
